import { Typography } from '@ui';
import ProviderCreateForm from '@pages/provider/create-provider/components/provider-create-form';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';

const CreateProviderOnboarding: React.FunctionComponent = () => {
  const { replace } = useHistory();
  const { formatMessage } = useIntl();

  const afterCreate = React.useCallback(() => {
    replace('/');
  }, []);

  return (
    <>
      <Typography display="h4">
        {formatMessage({ id: 'provider.onboarding.form.title' })}
      </Typography>
      <ProviderCreateForm afterSubmit={afterCreate} />
    </>
  );
};

export default CreateProviderOnboarding;
